import { GroupedInputOptions } from "./GeneralUtils";

// 施設タイプ
export const facilityTypeOptions: Array<[string, string]> = [
  ["studio", "撮影スタジオ"],
  ["internet_cafe", "インターネットカフェ"],
  ["event_hall", "イベント会場（有観客）"],
  ["hotel", "ホテル"],
];

export const convertFacilityTypes = (types: Array<string>) => {
  const object = Object.fromEntries(facilityTypeOptions);

  const results: Array<string> = [];
  types.forEach((type) => {
    if (object[type]) results.push(type);
  });

  return results.sort();
};

// 施設特徴
export const facilityTraitOptions: GroupedInputOptions = [
  {
    name: "利用形態",
    options: [
      ["for_groups", "団体向け"],
      ["no_reservation_required", "予約不要"],
      ["hall_rental", "会場レンタル"],
    ],
  },
  {
    name: "設備",
    options: [
      ["free_Wi-Fi", "Free Wi-Fi"],
      ["private_room", "個室"],
      ["streaming_booth", "配信ブースあり"],
    ],
  },
  {
    name: "サービス",
    options: [
      ["food_and_drink_sales", "飲食物販売あり"],
      ["allowed_food_and_drink", "飲食持込可能"],
      ["allowed_device", "デバイスの持込可"],
      ["device_rental", "デバイス貸し出し可"],
    ],
  },
  {
    name: "支払い関連",
    options: [
      ["student_discount", "学割"],
      ["e-money_payment", "電子マネー決済OK"],
    ],
  },
  {
    name: "アクセス周辺情報",
    options: [["station_near", "駅チカ"]],
  },
  {
    name: "その他",
    options: [["open_24_hours", "24時間営業"]],
  },
];

export const traitsToDisplayNames = (traits: Array<string>) => {
  const object = Object.fromEntries(
    facilityTraitOptions.map((group) => group.options).flat()
  );

  const results: Array<string> = [];
  traits.forEach((t) => {
    if (object[t]) results.push(object[t]);
  });

  return results;
};

export const convertFacilityTraits = (traits: Array<string>) => {
  const object = Object.fromEntries(
    facilityTraitOptions.map((group) => group.options).flat()
  );

  const results: Array<string> = [];
  traits.forEach((t) => {
    if (object[t]) results.push(t);
  });

  return results.sort();
};
